import { IActionContext } from '../helpers/ActionContext';
import { SchedulingErrorCode } from '../helpers/ErrorCodes';
import { L10n } from '../L10n/L10n';
import { DatasourceContentType, WorkbookContentType } from '../models/ContentTypes';
import { IExtractTaskInfo } from '../models/IExtractTaskInfo';
import { IErrorItem } from '../models/MultipleItemResult';
import { INamedItemInfo } from '../models/resourceInfoParts';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { ExtractTasks } from '../resources/ExtractTasks';
import { IResult } from '../ServerApi/types/IResponse';
import { ActionHelpers } from './ActionHelpers';
import { ConfirmActionDialog, IConfirmActionDialogInstance } from './ConfirmActionDialog';
import { ContentUrlForItem } from './ContentUrl';

export class DeleteExtractTasksAction {

  public static $inject = ['ConfirmActionDialog', 'ActionHelpers', '$translate', 'ExtractTasks'];

  constructor(
    private ConfirmActionDialog: ConfirmActionDialog,
    private ActionHelpers: ActionHelpers,
    private $translate: ng.translate.ITranslateService,
    private ExtractTasks: ExtractTasks
  ) { }

  public executeWithContext(extractTasks: Set<IExtractTaskInfo>, context: IActionContext): ng.IPromise<IResult> {

    let description: string;
    if(extractTasks.size() === 1) {
      const task = extractTasks.first();
      if (task.workbook) {
        description = this.$translate.instant('confirmDeleteExtractWorkbook', { PARENT_NAME: L10n.elideIfLong(task.workbook.name) });
      } else if (task.datasource) {
        description = this.$translate.instant('confirmDeleteExtractDatasources', { PARENT_NAME: L10n.elideIfLong(task.datasource.name) });
      }
    } else {
      description = this.$translate.instant('confirmDeleteExtracts', {
        ITEM_COUNT: extractTasks.size()
      }, L10n.Interpolations.Count);
    }

    return this.ConfirmActionDialog.open({
      scope: context.scope,
      title: this.$translate.instant('deleteMessage'),
      bodyText: description,
      actionName: this.$translate.instant('confirmDeleteButton', { ITEM_COUNT: extractTasks.size() }, L10n.Interpolations.Count),
      isDeleteAction: true,

      action: (dialogInstance: IConfirmActionDialogInstance) => {

        return this.ExtractTasks.del(extractTasks.keys())
          .then(this.ActionHelpers.notifyStandardError(
            extractTasks,
            {
              successId: 'deleteExtractTasksSuccess',
              errorId: 'deleteExtractTasksError'
            },
            (errorItem: IErrorItem<IExtractTaskInfo>) => {
              const namedItem: INamedItemInfo = errorItem.item.workbook || errorItem.item.datasource;

              return {
                itemName: namedItem.name,
                itemUrl: this.urlFor(errorItem),
                errorMessage: this.errorMessageFor(errorItem)
              };
            }
          ));
      }
    }).result;
  }

  private urlFor(errorItem: IErrorItem<IExtractTaskInfo>): string {
    let href: string;
    if(errorItem.item.workbook) {
      href = ContentUrlForItem(errorItem.item.workbook, WorkbookContentType);
    }
    if(errorItem.item.datasource) {
      href = ContentUrlForItem(errorItem.item.datasource, DatasourceContentType);
    }
    return href;
  }

  private errorMessageFor(errorItem: IErrorItem<IExtractTaskInfo>) {
    switch (errorItem.error.code) {
      case SchedulingErrorCode.SchedulingTaskNotFound:
        if(errorItem.item.workbook)
          return this.$translate.instant('errorExtractTaskForWorkbookNotFound', {
            WORKBOOK_NAME: L10n.elideIfLong(errorItem.item.workbook.name),
            SCHEDULE_NAME: L10n.elideIfLong(errorItem.item.schedule.name)
          });
        if(errorItem.item.datasource)
          return this.$translate.instant('errorExtractTaskForDatasourceNotFound', {
            DATASOURCE_NAME: L10n.elideIfLong(errorItem.item.datasource.name),
            SCHEDULE_NAME: L10n.elideIfLong(errorItem.item.schedule.name)
          });
    }
  }

}

Module.instance().service('DeleteExtractTasksAction', DeleteExtractTasksAction);
